import localForage from 'localforage';

const storageName = 'book';
const storageVersion = 1.0;
const storageDescription = 'Storage for the book';

localForage.config({
  name: storageName,
  version: storageVersion,
  storeName: storageName, // Should be alphanumeric, with underscores.
  description: storageDescription,
});

export default localForage;



// WEBPACK FOOTER //
// ./book/src/commons/offline/localForageProvider.js